import React, { useState, useEffect, useRef } from "react"
import '../../assets/css/views/activities/prices.css'
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Select, Button, Table, TableData, TableColumns, TablePreferences, TableColumnWidth, SelectOption, SelectInterface, ContextualMenu, IconPencil, IconTrash, Modal, ButtonGroup, IconWarningAlt, OptionInterface, TextBox, IconPlus, IconMinus, IconRemoteControl, IconUndo, Checkbox, TextArea, Card } from "@veneer/core";
import appointmentService from "../../services/agendaApi/appointment.service";
import { IUserDto } from "../../models/dto/generalApi/IUserDto";
import { IAppointmentDto } from "../../models/dto/agendaApi/IAppointmentDto";
import { IBrandDto } from "../../models/dto/agendaApi/IBrandDto";
import { IPriceProductDto } from "../../models/dto/agendaApi/IPriceProductDto";
import pricesService from "../../services/agendaApi/prices.service";
import { IProductByBrandDto } from "../../models/dto/agendaApi/IProductDto";
import { IProductPriceIn } from "../../models/input/agendaApi/IProductPriceIn";
import { IPriceProductBySkuDto } from "../../models/dto/agendaApi/IPriceProductBySkuDto";
import { IPromoProductsDto } from "../../models/dto/agendaApi/IPromoProductsDto";
import { useSelector } from "react-redux";
import { RootState } from "../../app/store";
import { NumberFormatBase } from 'react-number-format';
import BackButton from "../../features/path/backButton";
import { BreadCrumbsEnum } from "../../models/enum/BreadCrumbsEnum";
import { CountryEnum } from "../../models/enum/CountryEnum";
import { decryptText } from "../../utils/encryptionUtils";




export default function PricesAppointment() {

    const params = useParams();
    const [t] = useTranslation("global");
    const languageId: any = useSelector((state: RootState) => state.languageId);
    type SelectValue = number | string | boolean; //CHECK
    const state: any = useSelector((state: RootState) => state.user);
    //Loadings
    const [loadingTableData, setLoadingTableData] = useState(false);

    //shows
    const [showModalAddProductPrice, setShowModalAddProductPrice] = useState(false);
    const [showModalDeletePriceProduct, setShowModalDeletePriceProduct] = useState(false);
    const [showModalEditProductPrice, setShowModalEditProductPrice] = useState(false);


    //Data
    const [tableData, setTableData] = useState<TableData[]>([]);
    const [tableDataFiltered, setTableDataFiltered] = useState<TableData[]>([]);
    const [brands, setBrands] = useState<SelectOption[]>([]);
    const [productUncreatedData, setProductUncreatedData] = useState<SelectOption[]>([]);
    const [productUncreatedDataFiltered, setProductUncreatedDataFiltered] = useState<SelectOption[]>([]);
    const [promoProductsData, setPromoProductsData] = useState<SelectOption[]>([]);
    const [productsEdit, setProductsEdit] = useState<SelectOption[]>([]);
    const [skuList, setSkuList] = useState<string[]>([]);
    const actualPosCode = useRef('');
    const [appointmentActivityId, setAppointmentActivityId] = useState(NaN);
    const [activityId, setActivityId] = useState(NaN);


    const [country, setCountry] = useState(NaN);
    const [brandId, setBrandId] = useState(NaN);


    //Selects
    const [brandSelected, setBrandSelected] = useState<SelectValue[]>([]);
    const [productSelected, setProductSelected] = useState<SelectValue[]>([]);
    const [promoSelected, setPromoSelected] = useState<SelectValue[]>([]);
    const [productSelectedEdit, setProductSelectedEdit] = useState<SelectValue[]>([]);



    //Textbox
    const [referencePrice, setReferencePrice] = useState<string>('');
    const [price, setPrice] = useState<string>('');
    const [referencePricePromo, setReferencePricePromo] = useState<string>('');
    const [pricePromo, setPricePromo] = useState<string>('');
    const [details, setDetails] = useState<string>('');


    //Checkbox
    const [checkboxPrice, setCheckboxPrice] = useState<boolean>(true);
    const [checkboxPromo, setCheckboxPromo] = useState<boolean>(false);


    const [defaultCheckedPrice, setDefaultCheckedPrice] = useState<boolean>(true);


    //Search
    const [search, setSearch] = useState<string>();


    //Disables
    const [addProductPriceButtonDisable, setAddProductPriceButtonDisable] = useState(true);
    const [addProductsButtonDisable, setAddProductsButtonDisable] = useState(true);
    const [productUncreatedSelectDisable, setProductUncreatedSelectDisable] = useState(true);
    const [editProductPriceButtonDisable, setEditProductPriceButtonDisable] = useState(true);
    const [selectPromos, setSelectPromos] = useState(true);


    //reads
    const [readOnlyPrice, setReadOnlyPrice] = useState<boolean>(false);
    const [readOnlyPricePromo, setReadOnlyPricePromo] = useState<boolean>(false);



    useEffect(() => {
        getBrandsData()
        let id = Number(params.id);
        let activityId = Number(params.activityId);
        setActivityId(id)
        setAppointmentActivityId(activityId);
    }, [])

    useEffect(() => {
        if (!Number.isNaN(brandId)) {
            getTableData()
            setAddProductsButtonDisable(false)
        } else {
            setAddProductsButtonDisable(true)
        }
    }, [brandId])

    useEffect(() => {
        if (productSelected.length !== 0) {
            pricesService.getPriceProductBySku(String(actualPosCode.current), String(productSelected)).then(r => {
                fillDataforPriceCreation(r)
            });

        }
    }, [productSelected])

    useEffect(() => {
        if (productSelected.length !== 0 && price !== '') {
            setAddProductPriceButtonDisable(false)
        } else {
            setAddProductPriceButtonDisable(true)
        }
    }, [price, productSelected])


    useEffect(() => {
        if (productSelectedEdit.length !== 0 && price !== '') {
            setEditProductPriceButtonDisable(false)
        } else {
            setEditProductPriceButtonDisable(true)
        }
    }, [price, productSelectedEdit])

    useEffect(() => { }, [languageId])



    const getBrandsData = () => {
        
        setCountry(Number(decryptText(state.user.countryId))) //13
        pricesService.getBrands().then(r => {
            fillBrands(r)
        });

    }

    const fillDataforPriceCreation = (data: IPriceProductBySkuDto[]) => {

        if (Number(data[0].referencePrice) === Number(data[0].regularPrice)) {
            if (data[0].regularPrice !== null) {
                setPrice(String(data[0].regularPrice))
            }
            if (data[0].referencePrice !== 0) {
                setReferencePrice(String(data[0].referencePrice))
            }
            setDefaultCheckedPrice(true)
            setCheckboxPrice(true)
        } else {
            if (data[0].regularPrice === null) {
                if (data[0].referencePrice !== 0) {
                    setReferencePrice(String(data[0].referencePrice))
                    setPrice(String(data[0].referencePrice))
                    setDefaultCheckedPrice(true)
                    setCheckboxPrice(true)
                }
            } else {
                if (data[0].regularPrice !== null) {
                    setPrice(String(data[0].regularPrice))
                }
                if (data[0].referencePrice !== 0) {
                    setReferencePrice(String(data[0].referencePrice))
                }
                setDefaultCheckedPrice(false)
                setCheckboxPrice(false)

            }

        }

        if (data[0].promo !== null) {
            setPricePromo(String(data[0].promo))
        }

        if (data[0].referencePromo !== 0) {
            setReferencePricePromo(String(data[0].referencePromo))
        }


    }

    const fillBrands = (data: IBrandDto[]) => {
        const brandsTemp: SelectOption[] = [];

        for (let i = 0; i < data.length; i++) {
            const brand: IBrandDto = data[i];
            let brandTemp: SelectOption;
            brandTemp = {
                'value': brand.brandID,
                'label': brand.brandName,
            }
            brandsTemp.push(brandTemp);
        }
        setBrands(brandsTemp);
        setBrandId(Number(brandsTemp[0].value))
        setBrandSelected([brandsTemp[0].value])
    }


    const getTableData = () => {
        setLoadingTableData(true)
        let id = Number(params.id);
        appointmentService.getAppointmentByUser()
            .then(r => {
                getPosCode(r, id)
            })
    }



    const getPosCode = (data: IAppointmentDto[], id: number) => {
        let posCode = data.find(x => x.appointmentId === id)?.posCode;
        if (posCode) {
            //BRABIG012
            actualPosCode.current = posCode;
            getPricesProducts(posCode)
        } else { alert("Error") }
    }

    const getPricesProducts = (posCode: string) => {
        pricesService.getPricesProducts(posCode, brandId)
            .then(r => {
                fillDataPrices(r, Number(decryptText(state.user.countryId))) //13
                fillSkuList(r)
                fillProducts(r)
            }).finally(() => setLoadingTableData(false));
    }

    const getUncreatedProducts = () => {
        pricesService.getProducts(actualPosCode.current, brandId)
            .then(r => {
                filterUncreatedProducts(r)
            }).finally(() => setProductUncreatedSelectDisable(false));

    }

    const getPromos = () => {
        pricesService.getPromos(languageId.value)
            .then(r => {
                fillPromos(r);
            }).finally(() => setSelectPromos(false));

    }

    const getProductBySku = (sku: string) => {
        pricesService.getPriceProductBySku(String(actualPosCode.current), sku).then(r => {
            fillProductInforForEdit(r)
        });

    }


    const fillSkuList = (data: IPriceProductDto[]) => {
        const skuList: string[] = [];

        for (let i = 0; i < data.length; i++) {
            skuList.push(data[i].sku);
        }
        setSkuList(skuList);
    }

    const fillProducts = (data: IPriceProductDto[]) => {
        const productData: SelectOption[] = [];

        for (let i = 0; i < data.length; i++) {
            const product: IPriceProductDto = data[i];
            let selectProductData: SelectOption;
            selectProductData = {
                'value': product.sku,
                'label': product.productName,
            }
            productData.push(selectProductData);
        }
        setProductsEdit(productData);
    }


    const filterUncreatedProducts = (data: IProductByBrandDto[]) => {
        const productUncreatedData: IProductByBrandDto[] = data.filter(function (item) {
            if (skuList.includes(item.sku)) {
            } else {
                return item
            }
        });
        fillDataProductUncreated(productUncreatedData)
    }

    const fillDataProductUncreated = (data: IProductByBrandDto[]) => {
        const productUncreatedData: SelectOption[] = [];

        for (let i = 0; i < data.length; i++) {
            const product: IProductByBrandDto = data[i];
            let selectProductData: SelectOption;
            selectProductData = {
                'value': product.sku,
                'label': product.productName,
            }
            productUncreatedData.push(selectProductData);
        }
        setProductUncreatedData(productUncreatedData);
        setProductUncreatedDataFiltered(productUncreatedData);
    }

    const fillDataPrices = (data: IPriceProductDto[], countryId: number) => {
        const pagedData: TableData[] = [];
        if (country === CountryEnum.brasil1 || country === CountryEnum.brasil2 || country === CountryEnum.brasil3) {
            for (let i = 0; i < data.length; i++) {
                const price: IPriceProductDto = data[i];
                let tableData: TableData = {};
                tableData = {
                    'posCode': price.poS_Code,
                    'sku': price.sku,
                    'productName': price.productName,
                    'productModel': price.productModel,
                    'price': price.price,
                    'rowConfig': {
                        action: <ContextualMenu
                            onClick={handleActionRowConfig}
                            options={[
                                { value: price.sku, label: t("header.edit"), icon: <IconPencil /> },
                            ]}
                            placement="leading"
                        />,
                        disabled: false,
                        noWrap: false,
                        selected: false,

                    }
                }
                pagedData.push(tableData);
            }
            setTableData(pagedData);
            setTableDataFiltered(pagedData);

        } else {
            for (let i = 0; i < data.length; i++) {
                const price: IPriceProductDto = data[i];
                let tableData: TableData = {};
                tableData = {
                    'posCode': price.poS_Code,
                    'sku': price.sku,
                    'productName': price.productName,
                    'productModel': price.productModel,
                    'price': price.price,
                    'rowConfig': {
                        action: <ContextualMenu
                            onClick={handleActionRowConfig}
                            options={[
                                { value: price.sku, label: t("header.edit"), icon: <IconPencil /> },
                                { value: price.sku, label: t("header.delete"), icon: <IconTrash /> },

                            ]}
                            placement="leading"
                        />,
                        disabled: false,
                        noWrap: false,
                        selected: false,

                    }
                }
                pagedData.push(tableData);
            }
            setTableData(pagedData);
            setTableDataFiltered(pagedData);

        }


    }

    const fillPromos = (data: IPromoProductsDto[]) => {
        const productData: SelectOption[] = [];

        for (let i = 0; i < data.length; i++) {
            const product: IPromoProductsDto = data[i];
            let selectProductData: SelectOption;
            selectProductData = {
                'value': product.itemID,
                'label': product.promoItem,
            }
            productData.push(selectProductData);
        }
        setPromoProductsData(productData);
    }


    const fillProductInforForEdit = (data: IPriceProductBySkuDto[]) => {

        setProductSelectedEdit([data[0].sku]);

        let array = data[0].promoIncludes.split(',');
        const valueCopy: SelectValue[] = [];
        for (const promo of array) {
            if (Number(promo) !== 0) {
                valueCopy.push(Number(promo))
            }
        }
        setPromoSelected(valueCopy)

        if (Number(data[0].referencePrice) === Number(data[0].regularPrice)) {
            if (data[0].regularPrice !== null) {
                setPrice(String(data[0].regularPrice))
            }
            if (data[0].referencePrice !== 0) {
                setReferencePrice(String(data[0].referencePrice))
            }
            setDefaultCheckedPrice(true)
            setCheckboxPrice(true)
        } else {
            if (data[0].regularPrice === null) {
                if (data[0].referencePrice !== 0) {
                    setReferencePrice(String(data[0].referencePrice))
                    setPrice(String(data[0].referencePrice))
                    setDefaultCheckedPrice(true)
                    setCheckboxPrice(true)
                }
            } else {
                if (data[0].regularPrice !== null) {
                    setPrice(String(data[0].regularPrice))
                }
                if (data[0].referencePrice !== 0) {
                    setReferencePrice(String(data[0].referencePrice))
                }
                setDefaultCheckedPrice(false)
                setCheckboxPrice(false)

            }

        }


        if (data[0].promo !== null) {
            setPricePromo(String(data[0].promo))
        }

        if (data[0].referencePromo !== 0) {
            setReferencePricePromo(String(data[0].referencePromo))
        }

    }



    const columns: TableColumns[] = [
        {
            id: 'productName',
            label: t("header.productName"),
        },
        {
            id: 'price',
            label: t("header.prices"),
        },


    ];

    const columnsWidth: TableColumnWidth[] = [

        {
            columnId: 'productName',
            width: "70%"
        },
        {
            columnId: 'price',
            width: "30%"
        },


    ]

    const tablePreferences: TablePreferences = {
        width: columnsWidth
    }

    const handleActionRowConfig = (e: React.SyntheticEvent, option?: OptionInterface) => {
        getPromos()
        if (option) {
            if (option.label === "Edit" || option.label === "Editar" || option.label === "Editar") {
                getProductBySku(String(option.value))
                setShowModalEditProductPrice(true)

            } else if (option.label === "Delete" || option.label === "Eliminar" || option.label === "Excluir") {
                getProductBySku(String(option.value))
                setShowModalDeletePriceProduct(true)
            }


        }

    }

    const handleChangeSearch = (value: string) => {

        setSearch(value);
        const filterArray = tableData.filter((element) => {
            if (element.productName.toString().toLowerCase().includes(String(value).toLowerCase()) || element.sku.toString().toLowerCase().includes(String(value).toLowerCase())) {
                return element;
            }
        });
        setTableDataFiltered(filterArray)

    }

    const handleChangeSearchSelectProduct = (value: string) => {
        const filterArray = productUncreatedData.filter((element) => {
            if (element.value.toString().toLowerCase().includes(String(value).toLowerCase()) || element.label?.toString().toLowerCase().includes(String(value).toLowerCase())) {
                return element;
            }
        });
        setProductUncreatedDataFiltered(filterArray)

    }


    const handleChangeBrand = (value: SelectValue) => {
        setBrandId(Number(value));
        setBrandSelected([value])
    }

    const onClearBrand = () => {
        setBrandId(NaN);
        setBrandSelected([])
        setTableData([]);
        setTableDataFiltered([]);

    }

    const handleChangeProduct = (value: SelectValue) => {
        setProductSelected([value])
    }

    const onClearProduct = () => {
        setProductSelected([]);
    }

    const handleChangePrice = (value: string) => {
        setPrice(value)
    }
    const handleChangePricePromo = (value: string) => {
        setPricePromo(value)
    }
    const handleChangeCheckboxPrice = () => {
        if (!checkboxPrice === true) {
            setCheckboxPrice(!checkboxPrice)
            setReadOnlyPrice(true)
            setPrice(referencePrice)
        } else {
            setCheckboxPrice(!checkboxPrice)
            setReadOnlyPrice(false)
            setPrice('')
        }
    }
    const handleChangeCheckboxPromo = () => {
        if (!checkboxPromo === true) {
            setCheckboxPromo(!checkboxPromo)
            setReadOnlyPricePromo(true)
            setPricePromo(referencePricePromo)
        } else {
            setCheckboxPromo(!checkboxPromo)
            setReadOnlyPricePromo(false)
            setPricePromo('')
        }
    }

    const handleChangePromoSelected = (value: SelectValue) => {
        const valueCopy = [...promoSelected];
        const isOptionSelected = valueCopy.includes(value);
        if (isOptionSelected) {
            const index = valueCopy.indexOf(value);
            valueCopy.splice(index, 1);
        } else {
            valueCopy.push(value);
        }
        setPromoSelected(valueCopy);
    }
    const handleChangeDetails = (value: string) => {
        setDetails(value)
    }


    const resetCreationForm = () => {
        setProductSelected([])
        setProductSelectedEdit([])
        setPrice('')
        setReferencePrice('')
        setReferencePricePromo('')
        setPricePromo('')
        setCheckboxPrice(true)
        setCheckboxPromo(false)
        setPromoSelected([])
        setDetails('')
        setProductUncreatedData([])
        setProductUncreatedDataFiltered([])
    }



    const onAddPrices = () => {
        setShowModalAddProductPrice(true);
        getUncreatedProducts();
        getPromos();
    }



    const submitProductPrice = () => {
        let activityId = Number(params.activityId);
        let productsPrice: IProductPriceIn = {
            appointmentActivityID: activityId,
            sku: String(productSelected),
            regularPrice: Number.isNaN(parseInt(price)) ? 0 : parseInt(price),
            promoPrice: Number.isNaN(parseInt(pricePromo)) ? 0 : parseInt(pricePromo),
            comments: details,
            photo: '',
            promoInludes: String(promoSelected),
            deleted: 0
        }

        pricesService.updateProduct(productsPrice)
            .then(r => {
                setShowModalAddProductPrice(false)
                resetCreationForm()
                getTableData()
            })

    }

    const cancelAddProductPrice = () => {
        setShowModalAddProductPrice(false)
        resetCreationForm();
    }

    const deletePriceProduct = () => {
        let activityId = Number(params.activityId);
        let productsPrice: IProductPriceIn = {
            appointmentActivityID: activityId,
            sku: String(productSelectedEdit),
            regularPrice: Number.isNaN(parseInt(price)) ? 0 : parseInt(price),
            promoPrice: Number.isNaN(parseInt(pricePromo)) ? 0 : parseInt(pricePromo),
            comments: details,
            photo: '',
            promoInludes: String(promoSelected),
            deleted: 1
        }

        pricesService.updateProduct(productsPrice)
            .then(r => {
                setShowModalDeletePriceProduct(false)
                resetCreationForm()
                getTableData()
            })

    }
    const cancelDeletePriceProduct = () => {
        setShowModalDeletePriceProduct(false)
        resetCreationForm()
    }
    const submitEditProductPrice = () => {
        let activityId = Number(params.activityId);
        let productsPrice: IProductPriceIn = {
            appointmentActivityID: activityId,
            sku: String(productSelectedEdit),
            regularPrice: Number.isNaN(parseInt(price)) ? 0 : parseInt(price),
            promoPrice: Number.isNaN(parseInt(pricePromo)) ? 0 : parseInt(pricePromo),
            comments: details,
            photo: '',
            promoInludes: String(promoSelected),
            deleted: 0
        }

        pricesService.updateProduct(productsPrice)
            .then(r => {
                setShowModalEditProductPrice(false)
                resetCreationForm()
                getTableData()
            })

    }
    const cancelEditProductPrice = () => {
        setShowModalEditProductPrice(false)
        resetCreationForm()
    }



    return (
        <>
            {
                (() => {
                    if (Number.isNaN(country)) {
                        return (<div></div>)
                    }
                    else if (country === CountryEnum.brasil1 || country === CountryEnum.brasil2 || country === CountryEnum.brasil3) {
                        return (
                            <div className="prices">
                                <BackButton route={BreadCrumbsEnum.PriceShopping} activityId={activityId} appointmentActivityId={appointmentActivityId} />
                                <h4 className="pricesTitle">{t("header.prices")}</h4>

                                <div className="pricesDivTop">
                                    <Select
                                        className="pricesSelectBrand"
                                        label={t("header.brands")}
                                        onChange={e => handleChangeBrand(e.value)}
                                        onClear={onClearBrand}
                                        options={brands}
                                        value={brandSelected}
                                        placement="bottom-start"
                                    />
                                </div>

                                <Card
                                    appearance="outlined"
                                    className="pricesDiv"
                                    content={<>

                                        <TextBox
                                            className="searchPricesTextbox"
                                            label={t("header.search")}
                                            type="search"
                                            onChange={handleChangeSearch}
                                            value={search}
                                        />

                                        <Table
                                            className="priceProductTable"
                                            behavior={{
                                                type: 'singlePage',
                                            }}
                                            columnResize
                                            preferences={tablePreferences}
                                            loading={loadingTableData}
                                            columns={columns}
                                            data={tableDataFiltered}
                                            loadingDataLength={10}
                                            customNoItems={<div className="customNoItems"><div className="DivIconCustomNoItems"><IconWarningAlt className="IconCustomNoItems" /></div>{t("header.noItemsFound")}</div>}
                                        />
                                    </>}
                                />

                                <div style={{ position: 'relative' }}>
                                    <Modal
                                        className="modalEditProductPrice"
                                        closeButton={true}
                                        align="center"
                                        id="modalEditProductPrice"
                                        show={showModalEditProductPrice}
                                        onClose={cancelEditProductPrice}
                                        footer={(
                                            <ButtonGroup className="createPriceProductButtongrouop">
                                                <Button disabled={editProductPriceButtonDisable} onClick={submitEditProductPrice} >{t("header.submit")}</Button>
                                                <Button onClick={cancelEditProductPrice} appearance="secondary">{t("header.cancel")}</Button>
                                            </ButtonGroup>
                                        )}
                                        title={t("header.editProducts")}
                                    >

                                        <div className="createProductPrice">
                                            <Select
                                                className="createProductPriceSelect"
                                                label={t("header.productName")}
                                                options={productsEdit}
                                                value={productSelectedEdit}
                                                readOnly
                                            />
                                            {productSelectedEdit.length === 0 ?
                                                <div></div>
                                                :
                                                <div>
                                                    {referencePrice !== '' ?
                                                        <div className="createProductPriceValues">
                                                            <div className="createProductPriceTextboxes">
                                                                <TextBox
                                                                    className="createProductPriceTextbox"
                                                                    label={t("header.referencePrice")}
                                                                    type="number"
                                                                    value={referencePrice}
                                                                    readOnly
                                                                />
                                                                <TextBox
                                                                    className="createProductPriceTextbox"
                                                                    label={t("header.regularPriceStore")}
                                                                    type="number"
                                                                    value={price}
                                                                    onChange={e => handleChangePrice(e)}
                                                                    readOnly={readOnlyPrice}
                                                                    inputComponent={NumberFormatBase}
                                                                />
                                                            </div>

                                                            <Checkbox
                                                                className="createProductPriceCheckbox"
                                                                id="checkbox"
                                                                value={checkboxPrice}
                                                                defaultChecked={defaultCheckedPrice}
                                                                onChange={handleChangeCheckboxPrice}
                                                                label={t("header.regularEqualReference")}
                                                            />

                                                        </div>
                                                        :
                                                        <div className="createProductPriceValuesText">
                                                            <TextBox
                                                                className="createProductPriceTextboxAlone"
                                                                label={t("header.regularPriceStore")}
                                                                type="number"
                                                                value={price}
                                                                onChange={e => handleChangePrice(e)}
                                                                inputComponent={NumberFormatBase}
                                                            />
                                                        </div>
                                                    }

                                                    {referencePricePromo !== '' ?
                                                        <div className="createProductPriceValues">
                                                            <div className="createProductPriceTextboxes">
                                                                <TextBox
                                                                    className="createProductPriceTextbox"
                                                                    label={t("header.pricePromotionReference")}
                                                                    type="number"
                                                                    value={referencePricePromo}
                                                                    readOnly

                                                                />
                                                                <TextBox
                                                                    className="createProductPriceTextbox"
                                                                    label={t("header.storePromotionPrice")}
                                                                    type="number"
                                                                    value={pricePromo}
                                                                    onChange={e => handleChangePricePromo(e)}
                                                                    readOnly={readOnlyPricePromo}
                                                                    inputComponent={NumberFormatBase}
                                                                />
                                                            </div>

                                                            <Checkbox
                                                                className="createProductPriceCheckbox"
                                                                id="checkbox"
                                                                value={checkboxPromo}
                                                                onChange={handleChangeCheckboxPromo}
                                                                label={t("header.promotionEqualReference")}
                                                            />
                                                        </div>
                                                        :
                                                        <div>
                                                            <TextBox
                                                                className="createProductPriceTextboxAlone"
                                                                label={t("header.storePromotionPrice")}
                                                                type="number"
                                                                value={pricePromo}
                                                                onChange={e => handleChangePricePromo(e)}
                                                                inputComponent={NumberFormatBase}
                                                            />
                                                        </div>

                                                    }

                                                    <Select
                                                        className="createProductPriceSelect"
                                                        label={t("header.promotionIncludes")}
                                                        options={promoProductsData}
                                                        placement="bottom-start"
                                                        value={promoSelected}
                                                        onChange={e => handleChangePromoSelected(e.value)}
                                                        onClear={() => setPromoSelected([])}
                                                        multiple
                                                    />

                                                    <TextArea
                                                        className="createProductPriceTextArea"
                                                        label={t("header.details")}
                                                        value={details}
                                                        onChange={e => handleChangeDetails(e)}
                                                    />
                                                </div>
                                            }
                                        </div>
                                    </Modal>
                                </div>
                            </div>
                        )

                    } else {
                        return (
                            <div className="prices">
                                <BackButton route={BreadCrumbsEnum.PriceShopping} activityId={activityId} appointmentActivityId={appointmentActivityId} />
                                <h4 className="pricesTitle">{t("header.prices")}</h4>

                                <div className="pricesDivTop">
                                    <Select
                                        className="pricesSelectBrand"
                                        label={t("header.brands")}
                                        onChange={e => handleChangeBrand(e.value)}
                                        onClear={onClearBrand}
                                        options={brands}
                                        value={brandSelected}
                                        placement="bottom-start"
                                    />
                                    <Button onClick={onAddPrices} disabled={addProductsButtonDisable} >{t("header.addProducts")}</Button>
                                </div>

                                <Card
                                    appearance="outlined"
                                    className="pricesDiv"
                                    content={<>
                                        <TextBox
                                            className="searchPricesTextbox"
                                            label={t("header.search")}
                                            type="search"
                                            onChange={handleChangeSearch}
                                            value={search}
                                        />
                                        <div className="priceProductDivTable">
                                            <Table
                                                className="priceProductTable"
                                                behavior={{
                                                    type: 'singlePage',
                                                }}
                                                columnResize
                                                preferences={tablePreferences}
                                                loading={loadingTableData}
                                                columns={columns}
                                                data={tableDataFiltered}
                                                loadingDataLength={10}
                                                customNoItems={<div className="customNoItems"><div className="DivIconCustomNoItems"><IconWarningAlt className="IconCustomNoItems" /></div>{t("header.noItemsFound")}</div>}
                                            />
                                        </div>
                                    </>}
                                />

                                <div style={{ position: 'relative' }}>
                                    <Modal
                                        className="modalCreateProductPrice"
                                        closeButton={true}
                                        align="center"
                                        id="modalCreateProductPrice"
                                        show={showModalAddProductPrice}
                                        onClose={cancelAddProductPrice}
                                        footer={(
                                            <ButtonGroup className="createPriceProductButtongrouop">
                                                <Button disabled={addProductPriceButtonDisable} onClick={submitProductPrice} >{t("header.submit")}</Button>
                                                <Button onClick={cancelAddProductPrice} appearance="secondary">{t("header.cancel")}</Button>
                                            </ButtonGroup>
                                        )}
                                        title={t("header.addProducts")}
                                    >

                                        <div className="createProductPrice">
                                            <Select
                                                className="createProductPriceSelect"
                                                label={t("header.productName")}
                                                options={productUncreatedDataFiltered}
                                                placement="bottom-start"
                                                value={productSelected}
                                                onChange={e => handleChangeProduct(e.value)}
                                                onClear={onClearProduct}
                                                showSearch
                                                onSearch={handleChangeSearchSelectProduct}
                                                disabled={productUncreatedSelectDisable}
                                            />
                                            {productSelected.length === 0 ?
                                                <div></div>
                                                :
                                                <div>
                                                    {referencePrice !== '' ?
                                                        <div className="createProductPriceValues">
                                                            <div className="createProductPriceTextboxes">
                                                                <TextBox
                                                                    className="createProductPriceTextbox"
                                                                    label={t("header.referencePrice")}
                                                                    type="number"
                                                                    value={referencePrice}
                                                                    readOnly
                                                                />
                                                                <TextBox
                                                                    className="createProductPriceTextbox"
                                                                    label={t("header.regularPriceStore")}
                                                                    type="number"
                                                                    value={price}
                                                                    onChange={e => handleChangePrice(e)}
                                                                    readOnly={readOnlyPrice}
                                                                    inputComponent={NumberFormatBase}
                                                                />

                                                            </div>

                                                            <Checkbox
                                                                className="createProductPriceCheckbox"
                                                                id="checkbox"
                                                                defaultChecked={defaultCheckedPrice}
                                                                value={checkboxPrice}
                                                                onChange={handleChangeCheckboxPrice}
                                                                label={t("header.regularEqualReference")}
                                                            />

                                                        </div>
                                                        :
                                                        <div className="createProductPriceValuesText">
                                                            <TextBox
                                                                className="createProductPriceTextboxAlone"
                                                                label={t("header.regularPriceStore")}
                                                                type="number"
                                                                value={price}
                                                                onChange={e => handleChangePrice(e)}
                                                                inputComponent={NumberFormatBase}
                                                            />
                                                        </div>
                                                    }

                                                    {referencePricePromo !== '' ?
                                                        <div className="createProductPriceValues">
                                                            <div className="createProductPriceTextboxes">
                                                                <TextBox
                                                                    className="createProductPriceTextbox"
                                                                    label={t("header.pricePromotionReference")}
                                                                    type="number"
                                                                    value={referencePricePromo}
                                                                    readOnly
                                                                />
                                                                <TextBox
                                                                    className="createProductPriceTextbox"
                                                                    label={t("header.storePromotionPrice")}
                                                                    type="number"
                                                                    value={pricePromo}
                                                                    onChange={e => handleChangePricePromo(e)}
                                                                    readOnly={readOnlyPricePromo}
                                                                    inputComponent={NumberFormatBase}
                                                                />

                                                            </div>

                                                            <Checkbox
                                                                className="createProductPriceCheckbox"
                                                                id="checkbox"
                                                                value={checkboxPromo}
                                                                onChange={handleChangeCheckboxPromo}
                                                                label={t("header.promotionEqualReference")}
                                                            />
                                                        </div>
                                                        :
                                                        <div>
                                                            <TextBox
                                                                className="createProductPriceTextboxAlone"
                                                                label={t("header.storePromotionPrice")}
                                                                type="number"
                                                                value={pricePromo}
                                                                onChange={e => handleChangePricePromo(e)}
                                                                inputComponent={NumberFormatBase}
                                                            />
                                                        </div>

                                                    }

                                                    <Select
                                                        className="createProductPriceSelect"
                                                        label={t("header.promotionIncludes")}
                                                        options={promoProductsData}
                                                        placement="bottom-start"
                                                        value={promoSelected}
                                                        onChange={e => handleChangePromoSelected(e.value)}
                                                        onClear={() => setPromoSelected([])}
                                                        disabled={selectPromos}
                                                        multiple
                                                    />

                                                    <TextArea
                                                        className="createProductPriceTextArea"
                                                        label={t("header.details")}
                                                        value={details}
                                                        onChange={e => handleChangeDetails(e)}
                                                    />

                                                </div>
                                            }
                                        </div>
                                    </Modal>
                                </div>

                                <div style={{ position: 'relative' }}>
                                    <Modal
                                        align="center"
                                        id="modalDeletePriceProduct"
                                        show={showModalDeletePriceProduct}
                                        onClose={cancelDeletePriceProduct}
                                        footer={(
                                            <ButtonGroup className="deletePriceProductButtongrouop">
                                                <Button onClick={deletePriceProduct}>{t("header.yes")}</Button>
                                                <Button onClick={cancelDeletePriceProduct} appearance="secondary">{t("header.cancel")}</Button>
                                            </ButtonGroup>
                                        )}
                                        title={t("header.deleteItem")}
                                    >
                                        <p>
                                            {t("header.questionDelete")}
                                        </p>
                                    </Modal>
                                </div>

                                <div style={{ position: 'relative' }}>
                                    <Modal
                                        className="modalEditProductPrice"
                                        closeButton={true}
                                        align="center"
                                        id="modalEditProductPrice"
                                        show={showModalEditProductPrice}
                                        onClose={cancelEditProductPrice}
                                        footer={(
                                            <ButtonGroup className="createPriceProductButtongrouop">
                                                <Button disabled={editProductPriceButtonDisable} onClick={submitEditProductPrice} >{t("header.submit")}</Button>
                                                <Button onClick={cancelEditProductPrice} appearance="secondary">{t("header.cancel")}</Button>
                                            </ButtonGroup>
                                        )}
                                        title={t("header.editProducts")}
                                    >

                                        <div className="createProductPrice">
                                            <Select
                                                className="createProductPriceSelect"
                                                label={t("header.productName")}
                                                options={productsEdit}
                                                value={productSelectedEdit}
                                                readOnly
                                            />
                                            {productSelectedEdit.length === 0 ?
                                                <div></div>
                                                :
                                                <div>
                                                    {referencePrice !== '' ?
                                                        <div className="createProductPriceValues">
                                                            <div className="createProductPriceTextboxes">
                                                                <TextBox
                                                                    className="createProductPriceTextbox"
                                                                    label={t("header.referencePrice")}
                                                                    type="number"
                                                                    value={referencePrice}
                                                                    readOnly
                                                                />
                                                                <TextBox
                                                                    className="createProductPriceTextbox"
                                                                    label={t("header.regularPriceStore")}
                                                                    type="number"
                                                                    value={price}
                                                                    onChange={e => handleChangePrice(e)}
                                                                    readOnly={readOnlyPrice}
                                                                    inputComponent={NumberFormatBase}
                                                                />

                                                            </div>

                                                            <Checkbox
                                                                className="createProductPriceCheckbox"
                                                                id="checkbox"
                                                                defaultChecked={defaultCheckedPrice}
                                                                value={checkboxPrice}
                                                                onChange={handleChangeCheckboxPrice}
                                                                label={t("header.regularEqualReference")}
                                                            />

                                                        </div>
                                                        :
                                                        <div className="createProductPriceValuesText">
                                                            <TextBox
                                                                className="createProductPriceTextboxAlone"
                                                                label={t("header.regularPriceStore")}
                                                                type="number"
                                                                value={price}
                                                                onChange={e => handleChangePrice(e)}
                                                                inputComponent={NumberFormatBase}
                                                            />
                                                        </div>
                                                    }

                                                    {referencePricePromo !== '' ?
                                                        <div className="createProductPriceValues">
                                                            <div className="createProductPriceTextboxes">
                                                                <TextBox
                                                                    className="createProductPriceTextbox"
                                                                    label={t("header.pricePromotionReference")}
                                                                    type="number"
                                                                    value={referencePricePromo}
                                                                    readOnly

                                                                />
                                                                <TextBox
                                                                    className="createProductPriceTextbox"
                                                                    label={t("header.storePromotionPrice")}
                                                                    type="number"
                                                                    value={pricePromo}
                                                                    onChange={e => handleChangePricePromo(e)}
                                                                    readOnly={readOnlyPricePromo}
                                                                    inputComponent={NumberFormatBase}
                                                                />

                                                            </div>

                                                            <Checkbox
                                                                className="createProductPriceCheckbox"
                                                                id="checkbox"
                                                                value={checkboxPromo}
                                                                onChange={handleChangeCheckboxPromo}
                                                                label={t("header.promotionEqualReference")}
                                                            />
                                                        </div>
                                                        :
                                                        <div>
                                                            <TextBox
                                                                className="createProductPriceTextboxAlone"
                                                                label={t("header.storePromotionPrice")}
                                                                type="number"
                                                                value={pricePromo}
                                                                onChange={e => handleChangePricePromo(e)}
                                                                inputComponent={NumberFormatBase}
                                                            />
                                                        </div>

                                                    }

                                                    <Select
                                                        className="createProductPriceSelect"
                                                        label={t("header.promotionIncludes")}
                                                        options={promoProductsData}
                                                        placement="bottom-start"
                                                        value={promoSelected}
                                                        onChange={e => handleChangePromoSelected(e.value)}
                                                        onClear={() => setPromoSelected([])}
                                                        multiple
                                                    />

                                                    <TextArea
                                                        className="createProductPriceTextArea"
                                                        label={t("header.details")}
                                                        value={details}
                                                        onChange={e => handleChangeDetails(e)}
                                                    />
                                                </div>
                                            }
                                        </div>
                                    </Modal>
                                </div>
                            </div>
                        )
                    }
                })()
            }
        </>
    );
}